import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../../../erp/services/base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class AutenticacaoPropostaService {
  private subjectToken: BehaviorSubject<string> = new BehaviorSubject('');
  private subjectAutenticado: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}

  buscarBeneficiario(id: string): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/${id}/HolderProposal`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  autenticar(dados: any): Observable<any> {
    return this.httpClient.post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/GenerateToken`, dados).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  reeviarToken(id: string): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/ResendToken?proposalId=${id}`, null)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  validarToken(id: string, token: string): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/ValidateToken?token=${token}&proposalId=${id}`,
        null,
      )
      .pipe(
        map(response => {
          sessionStorage.setItem('token', token);
          this.subjectToken.next(token);
          this.subjectAutenticado.next(true);
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  atualizarToken(proposalId: string, token: string): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/Proposal/RefreshToken?token=${token}&proposalId=${proposalId}`,
        null,
      )
      .pipe(
        map(response => {
          sessionStorage.setItem('token', token);
          this.subjectToken.next(token);
          this.subjectAutenticado.next(true);
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  sairProposta() {
    sessionStorage.removeItem('token');
    this.subjectAutenticado.next(false);
  }

  verificarToken(): Observable<boolean> {
    const token = sessionStorage.getItem('token');
    const ehValido = !!token; // Verifica se o token existe e é válido
    this.subjectAutenticado.next(ehValido); // Atualiza o estado de autenticação
    return this.subjectAutenticado.asObservable();
  }

  validarInclusaoTitularCPF(idProposta: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Auth/${idProposta}/HolderProposal`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
}
